import { j as h } from "./jsx-runtime-3tyXYecC.mjs";
import { L as p } from "./link-unstyled-CvXR-8s6.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { m as x } from "./tss-DN0acMKN.mjs";
import { g as v } from "./get-encore-value-Di648HqV.mjs";
import { f as b } from "./format-base-props-8NDUNDcL.mjs";
const g = x()((s, a) => {
  const {
    borderRadiuses: l,
    mixins: { alpha: n },
    palette: t,
    typography: o,
    constructs: r
  } = s, { color: u, inheritFont: i, size: m } = a;
  let c = v(m, {
    "extra-small": e.ifFeature("encore", o.xsmall, o.teenie),
    small: o.small,
    medium: o.medium,
    large: o.large
  });
  i && (c = {
    fontSize: "inherit",
    lineHeight: "inherit"
  });
  const f = ((d) => {
    switch (d) {
      case "muted":
        return e.ifFeature("encore", r.text.link.muted, t.gray[700]);
      default:
        return e.ifFeature(
          "encore",
          i ? "inherit" : r.text.link.idle,
          i ? "inherit" : t.info.main
        );
    }
  })(u);
  return {
    root: {
      ...c,
      position: "relative",
      textDecoration: i ? "inherit" : "none",
      // only apply interactive styles if `href` is present
      "&:any-link": {
        color: f,
        fill: f,
        fontStyle: i ? "inherit" : "normal",
        fontWeight: i ? "inherit" : o.fontWeightMedium,
        ...e.ifFeature("encore", {
          "&:after": {
            borderRadius: l[200],
            bottom: -4,
            content: "''",
            display: "block",
            left: -8,
            position: "absolute",
            right: -8,
            top: -4,
            transition: "all 75ms"
          }
        }),
        "&:hover": {
          textDecoration: "underline"
        },
        "&:hover, &:focus-visible": {
          color: t.primary.main,
          fill: t.primary.main
        },
        ...e.ifFeature(
          "encore",
          {
            "&:focus-visible:after": {
              boxShadow: `0 0 0 2px ${n(r.surface.primary.medium, 0.8)}`
            }
          },
          {
            "&:focus-visible": {
              borderRadius: 2,
              boxShadow: `0 0 0 2px ${t.primary.lightest}`
            }
          }
        )
      }
    },
    inverted: {
      "&:any-link": {
        // @startCleanup encore
        fontWeight: e.ifFeature("encore", void 0, o.fontWeightBold),
        // @endCleanup encore
        textDecoration: e.ifFeature("encore", "underline"),
        "&:hover, &:focus-visible": {
          textDecoration: e.ifFeature("encore", "none", "underline")
        },
        "&, &:hover, &:focus-visible": {
          color: e.ifFeature("encore", r.text.neutral.inverted, t.common.white),
          fill: e.ifFeature("encore", r.text.neutral.inverted, t.common.white)
        },
        ...e.ifFeature(
          "encore",
          {
            "&:focus-visible:after": {
              boxShadow: `0 0 0 2px ${n(r.surface.neutral.inverted, 0.8)}`
            },
            "&:hover:after": {
              boxShadow: `0 0 0 2px ${n(r.surface.neutral.inverted, 0.3)}`
            }
          },
          {
            "&:focus-visible": {
              borderRadius: 2,
              boxShadow: `0 0 0 2px ${t.common.white}`
            }
          }
        )
      }
    }
  };
}), $ = (s) => {
  const { color: a, inheritFont: l, size: n, ...t } = s, { classes: o, cx: r } = g({ color: a, inheritFont: l, size: n });
  return /* @__PURE__ */ h.jsx(
    p,
    {
      ...b(t),
      className: r(o.root, { [o.inverted]: a === "inverted" }),
      "data-fabric-component": "Link"
    }
  );
};
export {
  $ as L
};
//# sourceMappingURL=link-0A1muLDU.mjs.map
